
export const TITLE = 'Buzón de Sugerencias para Colaboradores Internos';

// Llave de encriptacion
export const ENCRYPKEY: string = 'TJebkA5l#';

// Clave Id
export const CLAVEID: string = 'KfdfoM#hJ';
